import { useCallback } from 'react';
import { getFields } from 'src/azure/services/work-items';
import { findAllFieldTypesByWorkItemField } from '../../../utils/find-all-fields-types-by-wi-field';
import { WorkItemField } from 'azure-devops-extension-api/WorkItemTracking';

export function useWorkItemFieldHook() {
	const getWorkItemFieldOptions = useCallback(async (args: {
    projectId: string;
		selectedFieldValue: string;
  }) => {
		let results: Array<{ label: string; value: string }> = [];
		const fields = await getFields(args.projectId);

		if (fields) {
			const foundFields = fields.filter(field => field.referenceName !== 'System.TeamProject');
			const selectedField = foundFields.find(field => field.referenceName === args.selectedFieldValue);

			const conditionToFilter = (field: WorkItemField, selectedFieldItem: WorkItemField) => {
				const typeIsEqual = field.type === selectedFieldItem.type;

				if (selectedFieldItem.isIdentity && typeIsEqual) {
					return field.isIdentity;
				}

				if (selectedFieldItem.isPicklist && typeIsEqual) {
					return field.isPicklist;
				}

				return typeIsEqual;
			};

			if (!selectedField) {
				results = [];
			}

			if (selectedField) {
				results = findAllFieldTypesByWorkItemField(foundFields)
					.filter(field => conditionToFilter(field, selectedField))
					.map(item => ({ label: item.name, value: item.referenceName }));
			}
		}

		return results;
	}, []);

	return {
		getWorkItemFieldOptions,
	};
}